import { STORAGE_KEYS } from "../config/vars";

/**
 * Logout storage audit (client Android / web shell)
 *
 * REMOVED on logout — session, identity, navigation queues, badge markers:
 * - Auth: WR_MOBILE_ACCESS_TOKEN, WR_MOBILE_REFRESH_TOKEN, WR_ACTIVE_CLIENT_CONTEXT_ID
 * - Profile: clientId, clientName, emailForGoogle, locationId, networkId, forcePasswordChange, resetEmail
 * - Push session: WR_PENDING_PUSH_OPEN, WR_LAST_PUSH, WR_FCM_TOKEN_ANDROID_SENT
 * - Deep-link queues: pending*OpenId_client, pendingChatOpenTitle_client
 * - Read/badge markers: lastViewed*, newsSeenActivityById*
 * - Weather cache (not prefs): WR_CLIENT_WEATHER_CACHE
 *
 * KEPT on logout — device-level preferences (not tied to a logged-in user secret):
 * - WR_FCM_TOKEN_ANDROID (device push token; re-registered after next login)
 * - WR_APP_LOCK_ENABLED, WR_THEME_MODE, WR_CLIENT_WEATHER_* prefs, WR_CLIENT_WEATHER_CITY
 * - WR_CLIENT_NETWORK_BRANDING (logo rotate/pin prefs)
 * - WR_CLIENT_API_BASE_OVERRIDE, WR_CLIENT_SERVER_SELECTION_SEEN, WR_CLIENT_SERVER_SELECTION_UNLOCKED
 * - deviceId, powerGroup
 */

const LOGOUT_REMOVE_EXACT = [
    STORAGE_KEYS.MOBILE_ACCESS_TOKEN,
    STORAGE_KEYS.MOBILE_REFRESH_TOKEN,
    STORAGE_KEYS.ACTIVE_CLIENT_CONTEXT_ID,
    STORAGE_KEYS.FCM_TOKEN_ANDROID_SENT,
    STORAGE_KEYS.LAST_PUSH,
    "WR_PENDING_PUSH_OPEN",
    "clientId",
    "clientName",
    "emailForGoogle",
    "forcePasswordChange",
    "locationId",
    "networkId",
    "resetEmail",
    "pendingChatOpenHeadId_client",
    "pendingChatOpenTitle_client",
    "pendingNewsOpenId_client",
    "pendingOperatorInfoOpenId_client",
    "pendingPollOpenId_client",
    "pendingRequestOpenId_client",
    "pendingFeedbackOpenId_client",
    "pendingSensorOpenId_client",
    "pendingSensorEventOpenId_client",
    "pendingClientAccessRequestOpenId_client",
    "lastViewedNewsAt",
    "lastViewedNewsId",
    "lastViewedOperatorInfoAt",
    "lastViewedFeedbackAt",
    "lastViewedClientAccessAt",
    "lastViewedClientRequestsAt",
    "newsSeenActivityById",
    "WR_CLIENT_WEATHER_CACHE",
];

const LOGOUT_REMOVE_PREFIXES = [
    "newsSeenActivityById:",
    "lastViewedClientAccessAt:",
    "lastViewedClientRequestsAt:",
];

function safeRemoveItem(key) {
    try {
        localStorage.removeItem(key);
    } catch (_) {
        // ignore
    }
}

export function clearClientStorageOnLogout() {
    let clientId = null;
    try {
        clientId = localStorage.getItem("clientId");
    } catch (_) {
        clientId = null;
    }

    LOGOUT_REMOVE_EXACT.forEach(safeRemoveItem);

    if (clientId) {
        safeRemoveItem(`newsSeenActivityById:${clientId}`);
    }

    try {
        const keys = [];
        for (let i = 0; i < localStorage.length; i += 1) {
            const key = localStorage.key(i);
            if (key) keys.push(key);
        }
        keys.forEach((key) => {
            if (LOGOUT_REMOVE_PREFIXES.some((prefix) => key.startsWith(prefix))) {
                safeRemoveItem(key);
            }
        });
    } catch (_) {
        // ignore
    }
}

/** Same cleanup as logout; used when switching API server in mobile builds. */
export function clearStoredAuthStateForServerChange() {
    clearClientStorageOnLogout();
}

export function getClientLogoutStorageAudit() {
    const kept = [
        STORAGE_KEYS.FCM_TOKEN_ANDROID,
        "WR_APP_LOCK_ENABLED",
        "WR_THEME_MODE",
        "WR_CLIENT_WIDGETS_LAYOUT",
        "WR_CLIENT_WIDGETS_HINT_SEEN",
        "WR_CLIENT_WEATHER_ENABLED",
        "WR_CLIENT_WEATHER_CITY",
        "WR_CLIENT_WEATHER_SHOW_WIND",
        "WR_CLIENT_WEATHER_SHOW_PRESSURE",
        "WR_CLIENT_WEATHER_SHOW_HUMIDITY",
        STORAGE_KEYS.API_BASE_OVERRIDE,
        STORAGE_KEYS.SERVER_SELECTION_SEEN,
        "WR_CLIENT_SERVER_SELECTION_UNLOCKED",
        "deviceId",
        "powerGroup",
    ];

    return {
        removed: [...LOGOUT_REMOVE_EXACT, ...LOGOUT_REMOVE_PREFIXES.map((p) => `${p}*` )],
        kept,
    };
}
